import Vue from 'vue';
import Router from 'vue-router';
import WebApp from '@/components/WebApp';
import Login from '@/components/login/Login';
import DLService from 'dialogloopsdk';

const service = new DLService;
service.setLogLevel(4); // Debug

Vue.use(Router);

export default new Router({
    routes: [{
        path: '/',
        name: 'WebApp',
        component: WebApp,
        props: {
            service: service
        },
        query: {
            userId: 'userID',
            exp: 'exp',
            s: 'sessionCode',
            shortCode: 'shortCode',
            handle: 'handle',
            testAuth: 'testAuth'
        }
    }, {
        path: '/login',
        name: 'Login',
        component: Login,
        props: {
            service: service
        }
    }]
});

// Declare Event Bus
export const EventBus = new Vue();
export const LeadBus = new Vue();



// WEBPACK FOOTER //
// ./src/router/index.js